import React from 'react';
import variables from '../../styles/variables.module.scss';
import Highlight from '../../components/Highlight';

import footerBanner from '../../assets/envImages/abilia-footerBanner.jpg';
import env1 from '../../assets/envImages/abilia-env1.jpg';
// import hero from '../../assets/hero/abilia-hero-min.png';
import extraimg1 from '../../assets/frames/abilia-extraimg1-min.png';
import extraimg2 from '../../assets/frames/abilia-extraimg2-min.png';
import extraimg3 from '../../assets/frames/abilia-extraimg3-min.png';
import hero2 from '../../assets/hero/abilia-hero.jpg';

export default {
  path: '/cases/abilia',
  color: variables.abilia,
  // quoteData: {
  //   quote: '.',
  //   name: 'Nicklas Sehlin',
  //   profession: 'Head of SW Development, Abilia AB',
  // },
  hero: { fall: hero2 },
  env1: { fall: env1 },
  xtra: [
    { fall: extraimg1 },
    { fall: extraimg2 },
    { fall: extraimg3 },
  ],
  footerBanner: { fall: footerBanner },
  isAndroid: true,
  title: 'Handikalender',
  sideHeadingFirst: 'Android application',
  sideHeadingSecond: 'Developed in Java',
  infoTitle: 'What we built',
  infoBody:
  <span>
    Abilia needed help to develop a modern android app to be used by patients. They had a big backlog of tasks, the need to update a very old codebase and design, and a short deadline. As the service would also be used by patients of special needs, it demanded high quality in every aspect.
    <br />
    <br />
    For this project, We App used its agile approach, with a lot of interaction and meetings with Abilia's health care professionals. A
    {' '}
    <Highlight>design template</Highlight>
    {' was created. And a stable and robust Android mobile service was created, using '}
    <Highlight>Java</Highlight>
.
  </span>,
  infoData: {
    Scope: ['Scope', 'Project management', 'User experience', 'UI & UX design'],
    Deliverables: ['Deliverables', 'iOS development', 'Android development', 'Cross-platform', 'Software development'],
    Goal: ['Goal', 'Project management', 'User experience', 'UI & UX design', 'Maintanance/support'],
  },
  titleBodyData: {
    0: {
      title: 'Solutions that make a world of difference',
      body: 'Abilia is a health care organization that creates high quality solutions for people with special needs, and help enrich their lives by enabling them to live a more rich and full life. Abilia’s tools help people create structure in their everyday life, simplify communication with family members, control their home environment, or simplify the use of \'call for help\' alarms. The right tool at the right time, can make a world of difference.',
    },
    1: {
      title: 'Improving well-being and life quality with technology',
      body: 'We App is proud to have partnered with Abilia on this project. And to have worked on a project so aimed to improve people\'s well-being and life quality. The collaboration between Abilia and We App has been so successful that We App now have the proud responsibility to develop generation 2 of their service.',
    },
  },
};
